
const map = {
    height: '100%',
    width: '100%',
    padding: '10px',
};

export default map;
